import { render } from "./NostoProductRecommendations.vue?vue&type=template&id=0c60015e&scoped=true"
import script from "./NostoProductRecommendations.vue?vue&type=script&lang=js"
export * from "./NostoProductRecommendations.vue?vue&type=script&lang=js"

import "./NostoProductRecommendations.vue?vue&type=style&index=0&id=0c60015e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c60015e"]])

export default __exports__